import Image from 'next/image';
import React from 'react';
import { ProductColorPrice, ProductColorText } from './styled';
import { convertPrice } from '../../../Utils/ForeignUtils';
import { numberWithCommas } from '../../../Constants/HomePage';

function ProductColorInner(props) {
  const {
    productColorClickHandler,
    element,
    index,
    arrayUniqueByKey,
    focusElement,
    varientTitle,
    customReducerState,
    notSingleVariant,
    applyGestureEffect,
  } = props;
  const { price: elmPrice, symbol } = convertPrice(element?.price);
  return (
    <div
      className={focusElement == index ? 'lowOpacity' : ''}
      onClick={() => {
        applyGestureEffect(index);
      }}
      key={`colorboxes${index}`}
      id={
        index == 0
          ? `${element.title}first`
          : index == arrayUniqueByKey.length - 1
            ? `${element.title}last`
            : `productCards${index}`
      }
      style={{ maxWidth: '100px' }}
    >
      <li
        id={`${element.name + index}`}
        onClick={() => productColorClickHandler(element)}
        className={
          notSingleVariant
            ? ''
            : customReducerState[varientTitle.toUpperCase()] == element?.title
              ? 'color-varient'
              : 'not-selected-color'
        }
      >
        <Image
          src={element?.image}
          alt={`${element?.title} variant`}
          quality={90}
          height="75"
          width="75"
          className={
            notSingleVariant
              ? customReducerState[varientTitle.toUpperCase()] == element?.title
                ? 'color-varient'
                : 'not-selected-color'
              : ''
          }
        />
        {element?.title && notSingleVariant ? (
          <ProductColorText
            active={
              customReducerState[varientTitle.toUpperCase()] == element?.title
            }
          >
            <div>{element?.title}</div>
          </ProductColorText>
        ) : null}
        {!notSingleVariant ? (
          <ProductColorPrice>
            {symbol}
            {numberWithCommas(JSON.stringify(elmPrice))}
          </ProductColorPrice>
        ) : null}
      </li>
    </div>
  );
}

export default ProductColorInner;
